// 导入模块
import CuInputPopup from './Cu-InputPopup.vue';
export default CuInputPopup;


// WEBPACK FOOTER //
// ./src/packages/InputPopup/CuInputPopup/index.js